module.exports = __webpack_public_path__ + "img/platillo_panda.ebba2043.webp";